export const DATE_FORMAT = 'L LTS';
